<div class="container-fluid">
  <div class="card shadow-sm mb-4 position-relative">
    @if (isLoading) {
      <loader [config]="{ type: 'spinner', overlay: true, size: 'md' }"></loader>
    }

    <div class="card-header d-flex flex-wrap align-items-center gap-3">
      <div class="me-auto">
        <h3 class="card-title mb-0">Invoices due</h3>
      </div>

      <div class="report-date-navigator">
        <button type="button" class="btn btn-link btn-sm" title="Previous day" (click)="shiftDate(-1)">
          <i class="fa fa-solid fa-chevron-left"></i>
        </button>
        <input type="date" class="form-control form-control-sm" [formControl]="dateControl" aria-label="Report date" />
        @if (isToday) {
          <span class="report-today-badge">Today</span>
        } @else {
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="goToToday()">Today</button>
        }
        <button type="button" class="btn btn-link btn-sm" title="Next day" (click)="shiftDate(1)">
          <i class="fa fa-solid fa-chevron-right"></i>
        </button>
      </div>

      <button class="btn btn-outline-primary" type="button" [disabled]="isExporting" (click)="exportExcel()">
        <i class="bi bi-file-earmark-spreadsheet me-1"></i>Export Excel
      </button>
    </div>

    <div class="card-body">

      <div class="table-responsive">
        <table class="table finance-table mb-0">
          <thead>
            <tr>
              <th>Project</th>
              <th>Client Reference</th>
              <th>Instalment Amount</th>
              <th>Expected Due Date</th>
              <th>Payment Status</th>
              <th>Notes / Alerts</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.projectInvoiceId) {
              <tr>
                <td>{{ row.projectName }}</td>
                <td>{{ row.clientReference }}</td>
                <td class="finance-amount fw-semibold">{{ row.amount | currency: currency }}</td>
                <td class="text-nowrap" [class.finance-date-overdue]="isLate(row)">{{ formatDate(row.dueDate) }}</td>
                <td>
                  <span [class]="statusClass(row.status)">{{ statusLabel(row.status) }}</span>
                </td>
                <td>{{ row.notes || '—' }}</td>
                <td class="text-center">
                  <div class="btn-group">
                    <button type="button" class="btn btn-sm btn-action btn-primary"
                      ngbTooltip="Open project Finance Income" (click)="openProjectFinance(row)">
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
            @if (rows.length === 0 && !isLoading) {
              <tr>
                <td colspan="7" class="text-center text-muted">No instalments due on the selected date</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
